import type { FaireProductEntity } from "../../entity_types/product";

export const p_fwv9rfc6vj: FaireProductEntity = {
  token: "p_fwv9rfc6vj",
  type: "product",
  name: "Brown Bandana Fringe Crossbody",
  brandToken: "b_5m4wqw135i",
  brandName: "Panache Apparel Co.",
  imageUrl: "https://cdn.faire.com/fastly/ffdb8d5c818f7d9c6c81f33e5cf80ea7abac5801dcbcd9ee948303c7070d1cd4.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7c0641c1c1abf5b34d4112b4e236a1e1fb77f046821858153c1891d0ba746a92.jpeg",
    "https://cdn.faire.com/fastly/4ded98aea1248035dcf4f605efb956c608c509f2ed29b0aadf9be601665fc07a.jpeg"
  ],
  priceDollars: 37.95,
  description: "A brown bandana fringe crossbody featuring a classic paisley print, designed with a long crossbody strap and suede leather fringe detailing for a stylish western-inspired look. Roomy interior is perfect for carrying daily essentials while adding a statement touch to any outfit.\n\n14\" W x 10\" H\n\n100% Cotton\n\nMin. Qty: 2",
  tags: [],
  msrpDollars: 94.88,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:05:41.381Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
